import { StorageAdapter } from '@vuetify/v0/composables'
import { themeCookie, themeFromCookie } from './cookie'
import { isTheme, type Theme } from './themes'

export class CookieThemeStorage extends StorageAdapter {
  private readonly secure: boolean
  private readonly seed: Theme | undefined

  constructor(secure = typeof location !== 'undefined' && location.protocol === 'https:', seed?: Theme) {
    super()
    this.secure = secure
    this.seed = seed
  }

  getItem(key: string): string | null {
    if (key !== 'theme') return null
    if (typeof document === 'undefined') return this.seed ?? null

    return themeFromCookie(document.cookie) ?? null
  }

  setItem(key: string, value: string): void {
    if (key !== 'theme' || typeof document === 'undefined' || !isTheme(value)) return
    document.cookie = themeCookie(value, this.secure)
  }

  removeItem(key: string): void {
    if (key !== 'theme' || typeof document === 'undefined') return
    document.cookie = themeCookie(null, this.secure)
  }
}
